import { PLATFORM_REPORT_SUMMARY_LOADED } from "../actions/reportSummary.action";

const initialState = {
    summary: null,
};

export default function reportSummaryReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case PLATFORM_REPORT_SUMMARY_LOADED:
            return {
                ...state,
                summary: payload,
            }
        default:
            return state

    }
}